module.exports = __webpack_public_path__ + "img/icon_help@2x.eb44b040.png";